export default __webpack_public_path__ + "static/media/MARKPROBLACK.41c65b02.woff";